import { render, staticRenderFns } from "./Tesorería.vue?vue&type=template&id=5b91e4c4&"
import script from "./Tesorería.vue?vue&type=script&lang=js&"
export * from "./Tesorería.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tesorería.vue"
export default component.exports